import styled from 'styled-components';
import { ConnectorWrapper } from '../../../Builder/BuilderUI';
import { theme } from '../../../../styles/theme';

export const Bracket = styled.div`
  flex: 0 0 auto;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  color: ${theme.colors.mainBlue};
`;

export const LogicOp = styled(ConnectorWrapper)`
  height: auto;
  margin-right: 4px;
  margin-left: 4px;
  padding: 0 4px;
  line-height: 16px;
`;
